import * as React from "react";
import { FaqItem } from "@grandvisionhq/content";
import { PopupModal } from "../../../../PopupModal/v3/components/PopupModal/PopupModal.js";
/* empty css                    */
const AppointmentFaq = ({ title, faqItems, isOpen, onModalClose }) => /* @__PURE__ */ React.createElement(
  PopupModal,
  {
    className: "appointment-faq",
    title,
    isOpen,
    showIcon: true,
    onModalClose
  },
  faqItems?.map(({ id, question, answer }) => /* @__PURE__ */ React.createElement(FaqItem, { id, question, answer, key: id, appendIdToUrl: false }))
);
export {
  AppointmentFaq as default
};
//# sourceMappingURL=AppointmentFaq.js.map
